module.exports = __webpack_public_path__ + "img/img-3-14mobile.e14658ae.png";